// @flow

import { SET_CHAT_CHANNEL } from '../constants/actionTypes';

export function setChannel(channelId: string | number) {
  return {
    type: SET_CHAT_CHANNEL,
    channelId
  };
}
